<template>
  <div id="wt-header">
    <div id="wt-header-left">
      <div class="mr-3" id="wt-header-logo">
        <wtHeaderBrand></wtHeaderBrand>
      </div>
      <div id="wt-container-toggler">
        <wtHeaderToggler></wtHeaderToggler>
      </div>
    </div>

    <!--<div id="wt-header-center"></div>-->

    <div id="wt-header-right">
      <wtHeaderNotifications></wtHeaderNotifications>
      <wtHeaderAvatar></wtHeaderAvatar>
    </div>
  </div>
</template>

<script>
import wtHeaderBrand from "./wtHeaderBrand";
import wtHeaderToggler from "./wtHeaderToggler";
import wtHeaderAvatar from "./wtHeaderAvatar";
import wtHeaderNotifications from "./wtHeaderNotifications";

export default {
  name: "wt-header",
  components: {
    wtHeaderBrand,
    wtHeaderToggler,
    wtHeaderAvatar,
    wtHeaderNotifications
  },
  props: {},
  computed: {},
  methods: {}
};
</script>
<style>
</style>